import { IconButton, makeStyles, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@material-ui/lab";
import * as React from "react";
import { useState } from "react";
import { Create, required, SimpleForm, TextInput, useDataProvider, useNotify } from "react-admin";
import { useHistory } from "react-router-dom";
import CreatedByField from "../../../src/Components/ReferenceFields/CreatedBy/CreatedByField";
import { formatDate } from "../../../src/Helper/MomentHelper";

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: 40,
  },
  title: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "1em",
  },
  form: {
    [theme.breakpoints.up("xs")]: {
      width: 400,
    },
    [theme.breakpoints.down("xs")]: {
      width: "100vw",
      marginTop: -30,
    },
  },
  inlineField: {
    display: "inline-block",
    width: "50%",
  },
  ul: {
    listStyleType: "none",
  },
}));

const NotesTimeLine = ({ coreInfoRequestId }) => {
  const provider = useDataProvider();
  const [noteData, setNoteData] = useState<any>([] as any);
  const getNoteData = async () => {
    const { data } = await provider.getList("coreinforequestremarks", {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "id", order: "DESC" },
      filter: { coreInfoRequestId__eq: coreInfoRequestId },
    });

    if (data !== null && data !== undefined && data.length > 0) {
      let mappedData = data.map(item => ({
        remark: item.remark,
        createdBy: item.createdBy,
        createdDate: formatDate(item.createdDate),
      }));
      setNoteData(mappedData);
    }
  };

  React.useEffect(() => {
    getNoteData();
  }, [coreInfoRequestId]);

  return (
    <Timeline align="left">
      {noteData.map((item, key) => (
        <TimelineItem key={key}>
          <TimelineOppositeContent>
            <Typography color="textSecondary">{item.createdDate}</Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot variant="outlined" color="primary" />
            <TimelineConnector />
          </TimelineSeparator>

          <TimelineContent>
            {item.remark.match(/.{1,20}/g).map(element => {
              return <li title={element}>{element}</li>;
            })}
          </TimelineContent>
          <TimelineContent>
            <ul>
              <li>
                <strong>
                  <CreatedByField record={item} label={"Created By"} />
                </strong>
              </li>
            </ul>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
};

const CoreInfoRequestNotes = ({ onCancel, coreInfoRequest, ...props }) => {
  const classes = useStyles();
  const [value, setValue] = useState();
  const notify = useNotify();

  var history = useHistory();
  const onRedirect = () => {
    onCancel?.(value);
    notify(`Core Info Request Note Successfully Added`, "success", false, true);
    return history.location.pathname;
  };
  const onChange = e => {
    setValue(e.target.value);
  };
  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <Typography variant="h6">CREATE CORE INFO REQUEST NOTE</Typography>
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </div>
      <Create title={" "} {...props}>
        <SimpleForm redirect={onRedirect}>
          <TextInput
            source="coreInfoRequestId"
            label="Request"
            initialValue={coreInfoRequest.id}
            validate={required()}
            disabled
            fullWidth
            rows={3}
            variant="outlined"
          />
          <TextInput
            source="remark"
            label="Remark"
            validate={required()}
            multiline
            resettable
            fullWidth
            rows={3}
            variant="outlined"
            onChange={onChange}
          />
        </SimpleForm>
      </Create>
      <NotesTimeLine coreInfoRequestId={coreInfoRequest.id} />
    </div>
  );
};
export default CoreInfoRequestNotes;
